<template>
  <div>
    <div class="col-xs-12">
      <h2>{{ trans_choice('core.questions', 1) }}: {{ question.question }}</h2>
    </div>

    <div class="col-xs-12">
      <div class="row">
        <div class="col-xs-6">
          <table
            class="table"
          >
            <tr>
              <th>{{ trans('review.type.type') }}</th>
              <td>{{ trans('review.type.five_scale') }}</td>
            </tr>
            <tr>
              <th>{{ trans('review.times_asked') }}</th>
              <td>{{ question.responses.total }}</td>
            </tr>
            <tr>
              <th>{{ trans('review.times_answered') }}</th>
              <td>{{ question.responses.responses }}</td>
            </tr>
            <tr>
              <th>{{ trans('review.response_rate') }}</th>
              <td>{{ question.responses.percentage }}</td>
            </tr>
            <tr>
              <th>{{ trans('review.average_heading') }}</th>
              <td>{{ average }}</td>
            </tr>
          </table>
        </div>

        <div class="col-xs-6">
          <table
            class="table table-striped"
          >
            <tr>
              <th>{{ trans_choice('review.answer_possibilities', 1) }}</th>
              <th>{{ trans('review.absolute') }}</th>
              <th>{{ trans('core.percentage') }}</th>
            </tr>
            <tr
              v-for="answer in question.answers"
              :key="answer.answer"
            >
              <td>
                <span
                  class="square"
                  :style="{ backgroundColor: backgroundColors[answer.answer - 1] }"
                >&nbsp;</span> {{ labels[answer.answer - 1] }}
              </td>
              <td>{{ answer.responses }}</td>
              <td>{{ answer.percentage }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="col-xs-12">
        <h3>{{ trans('review.per_activity') }}</h3>
      </div>
      <div
        class="col-xs-12"
        style="page-break-before:always; page-break-after:always; width:100%;"
      >
        <bar-chart
          :bar_data="barData"
          :bar_options="barOptions"
          :chart-data="barData"
          :width="900"
          :height="500"
          :heigth="heigth"
          class="horizontal"
        />
      </div>
      <br style="clear:both">
    </div>
  </div>
</template>

<script>

import BarChart from './../../../../Charts/BarChart.js'
import ChartJSPluginDatalabels from 'chartjs-plugin-datalabels'

export default {
  name: 'FiveScaleLecturerAnalytics',

  components: { BarChart },

  props: {
    question: { required: true },
  },

  data () {
    return {
      backgroundColors: ['#B2182B', '#d6604d', '#D1E5F0', '#4393C3', '#2166AC'],
      labels: [
        Lang.get('review.answer_option.five_scale.1'),
        Lang.get('review.answer_option.five_scale.2'),
        Lang.get('review.answer_option.five_scale.3'),
        Lang.get('review.answer_option.five_scale.4'),
        Lang.get('review.answer_option.five_scale.5'),
      ],
    }
  },
  computed: {
    heigth () {
      return ((this.getLabelsBarChart().length > 0 ? this.getLabelsBarChart().length * 20 : '200') + 100)
    },

    barData () {
      return {
        labels: this.getLabelsBarChart(),

        datasets: [
          {
            backgroundColor: this.backgroundColors[0],
            data: this.getPercentages(1),
          },
          {
            backgroundColor: this.backgroundColors[1],
            data: this.getPercentages(2),
          },
          {
            backgroundColor: this.backgroundColors[2],
            data: this.getPercentages(3),
          },
          {
            backgroundColor: this.backgroundColors[3],
            data: this.getPercentages(4),
          },
          {
            backgroundColor: this.backgroundColors[4],
            data: this.getPercentages(5),
          },
        ],
      }
    },
    average () {
      const totals = Object.values(this.events).reduce((acc, event) => {
        Object.values(event.answers).map(answer => {
          acc.number = acc.number + answer.responses
          acc.total = acc.total + parseFloat(answer.answer) * answer.responses
          return answer
        })
        return acc
      }, { number: 0, total: parseFloat(0) })

      if (totals.number === 0) {
        return '-'
      }

      return Math.round((totals.total * 100) / totals.number) / 100
    },

    barOptions () {
      return {
        devicePixelRatio: 5,
        plugins: {
          datalabels: {
            color: function (context) {
              // Color the datalabel white if the background color is dark
              return [0, 4].includes(context.datasetIndex) ? 'white' : 'black'
            },
            textAlign: 'center',
            font: {
              size: 12,
            },
            formatter: (value, ctx) => {
              return value + '%'
            },
          },
        },
        responsive: false,
        maintainAspectRatio: true,
        responsiveAnimationDuration: 0,
        animation: { duration: 0 },

        legend: {
          display: false,
          labels: {
            fontColor: 'black',
          },
        },

        title: {
          display: false,
        },

        scales: {
          yAxes: [{
            stacked: true,
            maxBarThickness: 20,
            ticks: {
              min: 0,
              max: 100,
              stepSize: 20,
            },
            scaleLabel: {
              display: true,
              labelString: 'Percentages',
            },
          }],
          xAxes: [{
            stacked: true,
          }],
        },
      }
    },

    answers () {
      return _.orderBy(Object.values(this.question.answers), 'answer')
    },

    events () {
      return _.orderBy(Object.values(this.question.events), 'starttime')
    },
  },

  created () {
    Chart.defaults.global.defaultFontColor = 'black'
  },

  methods: {
    getPercentages (type = null) {
      let values = this.answers
      if (type != null) {
        values = Object.values(this.events).map(event => {
          return Object.values(event.answers).filter(answer => {
            return answer.answer == type
          })
        }).map(event => {
          return event[0]
        })
      }

      return Object.values(values).map(answer => {
        return answer.percentage_numeric != 0 ? answer.percentage_numeric : ''
      })
    },

    getLabelsBarChart () {
      return Object.values(this.events.map(event => {
        if (this.events.length > 3) {
          return (event.full_name + ', ' + event.date + ', ' + event.responses + ' ' + Lang.get('review.answers')).split(' ')
        } else {
          return [event.full_name, event.date, event.responses + ' ' + Lang.get('review.answers')]
        }
      }))
    },
  },
}
</script>

<style scoped type="text/css">
  td th {
    font-size:24px;
  }

  .table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 1rem;
  }

  .table th,
  .table td {
    padding: 0.75rem;
    vertical-align: top;
    border-top: 1px solid #eceeef;
  }

  .table thead th {
    vertical-align: bottom;
    border-bottom: 2px solid #eceeef;
  }

  .table tbody + tbody {
    border-top: 2px solid #eceeef;
  }

  .table .table {
    background-color: #fff;
  }

  .table-sm th,
  .table-sm td {
    padding: 0.3rem;
  }

  .table-bordered {
    border: 1px solid #eceeef;
  }

  .table-bordered th,
  .table-bordered td {
    border: 1px solid #eceeef;
  }

  .table-bordered thead th,
  .table-bordered thead td {
    border-bottom-width: 2px;
  }

  .table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
  }

  .table-hover tbody tr:hover {
    background-color: rgba(0, 0, 0, 0.075);
  }

  .table-active,
  .table-active > th,
  .table-active > td {
    background-color: rgba(0, 0, 0, 0.075);
  }

  .table-hover .table-active:hover {
    background-color: rgba(0, 0, 0, 0.075);
  }

  .table-hover .table-active:hover > td,
  .table-hover .table-active:hover > th {
    background-color: rgba(0, 0, 0, 0.075);
  }

  .table-success,
  .table-success > th,
  .table-success > td {
    background-color: #dff0d8;
  }

  .table-hover .table-success:hover {
    background-color: #d0e9c6;
  }

  .table-hover .table-success:hover > td,
  .table-hover .table-success:hover > th {
    background-color: #d0e9c6;
  }

  .table-info,
  .table-info > th,
  .table-info > td {
    background-color: #d9edf7;
  }

  .table-hover .table-info:hover {
    background-color: #c4e3f3;
  }

  .table-hover .table-info:hover > td,
  .table-hover .table-info:hover > th {
    background-color: #c4e3f3;
  }

  .table-warning,
  .table-warning > th,
  .table-warning > td {
    background-color: #fcf8e3;
  }

  .table-hover .table-warning:hover {
    background-color: #faf2cc;
  }

  .table-hover .table-warning:hover > td,
  .table-hover .table-warning:hover > th {
    background-color: #faf2cc;
  }

  .table-danger,
  .table-danger > th,
  .table-danger > td {
    background-color: #f2dede;
  }

  .table-hover .table-danger:hover {
    background-color: #ebcccc;
  }

  .table-hover .table-danger:hover > td,
  .table-hover .table-danger:hover > th {
    background-color: #ebcccc;
  }

  .thead-inverse th {
    color: #fff;
    background-color: #292b2c;
  }

  .thead-default th {
    color: #464a4c;
    background-color: #eceeef;
  }

  .table-inverse {
    color: #fff;
    background-color: #292b2c;
  }

  .table-inverse th,
  .table-inverse td,
  .table-inverse thead th {
    border-color: #fff;
  }

  .table-inverse.table-bordered {
    border: 0;
  }

  .table-responsive {
    display: block;
    width: 100%;
    overflow-x: auto;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }

  .table-responsive.table-bordered {
    border: 0;
  }

  .square {
    width: 25px;
    border-radius: 3px;
    min-height: 13px;
    display: inline-block;
  }
</style>
